export default vm => {
    return vm.profile.customerId
        ? vm.$emailbotDataProvider
            .get('permissions')
            .then(({ permissions }) => permissions)
            .catch(() => {})
        : Promise.resolve([]);
};
